import People from "@modules/common/icons/people";
import Image from "next/image";
import { motion } from "framer-motion";
import { StrapiImage } from "types/image";
import { getStrapiImagePath } from "@lib/utils/help";

function Team({ teamImage }: { teamImage: StrapiImage }) {
  return (
    <motion.div
      className="flex justify-center items-center md:min-h-[400px] h-[50vw] md:h-[75vh] w-full rounded-3xl mt-20 md:mt-40 md:flex-row flex-col-reverse relative"
      initial={{ opacity: 0, y: -30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.5 }}
      transition={{
        duration: 0.5,
        ease: "easeInOut",
      }}
    >
      <h1 className="absolute right-0 top-0 md:pt-2 pt-1 md:pb-6 pb-2 md:px-10 px-4 md:text-5xl text-base text-terryWhite bg-darkGreen rounded-bl-3xl z-20">
        Meet the Team
      </h1>{" "}
      <div className="flex justify-between items-center md:p-4 p-2 rounded-full bg-darkGreen text-terryWhite w-max absolute left-0 top-0 md:mt-4 mt-1 md:ml-10 ml-4 z-20">
        <People
          size="inherit"
          className="md:w-[35px] w-[20px] md:h-[35px] h-[20px]"
        />
      </div>
      <div className="w-full  bg-primary h-full rounded-3xl relative">
        <Image
          src={getStrapiImagePath(teamImage)}
          alt="team"
          fill
          style={{ objectFit: "cover" }}
          objectPosition="top"
          className="rounded-3xl"
          unoptimized
        />
      </div>
    </motion.div>
  );
}

export default Team;
